import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import CompanyQuotaPanel from './CompanyQuotaPanel';
import { fetchCompanyQuotaData, getTeamAndFiscalQuarters } from './redux/management.thunk';
import { clearManagementSlice } from './redux/management.slice';
import AddHeaderDescriptionWithHelperText from '../../components/HelperTextDescription';
import UpdateFiscalQuarterFilter from './components/UpdateFiscalQuarterFilter';
import QuotaRemoval from './QuotaManagement/QuotaRemoval';
import QuotaManagementToggle from './components/QuotaManagementToggle';
import AddCompanyQuotaView from './QuotaManagement/AddCompanyQuotaView';

const CompanyManagementContainer = () => {
  const [view, setView] = useState('add');
  const [touched, setTouched] = useState(false);
  const dispatch = useDispatch();

  const headerText = "Company Quota Management";
  const descriptionText = "Add / Delete / Update Quota for Companies";

  useEffect(() => {
    dispatch(getTeamAndFiscalQuarters({ type: 'company' }));

    return () => {
      dispatch(clearManagementSlice());
    };
  }, [dispatch]);

  const handleChangeView = (event, newView) => {
    if (newView !== null) {
      if (touched) {
        if (window.confirm("You have unsaved changes. Do you want to discard and switch view?")) {
          setView(newView);
          setTouched(false);
        }
      } else {
        setView(newView);
      }
    }
  };

  const toggleButtonStyle = (buttonView) => ({
    background: view === buttonView ? "#4472C4" : "",
    color: view === buttonView ? "white" : "",
    fontSize: "1rem",
    fontWeight: 600,
    height: "3.5rem",
    width: "16rem",
  });

  return (
    <Grid container spacing={2}>
      <Grid container item style={{ margin: "1rem 0rem" }}>
        <AddHeaderDescriptionWithHelperText
          header={headerText}
          description={descriptionText}
        />
      </Grid>
      <Grid item xs={12}>
        <QuotaManagementToggle
          section="Company"
          view={view}
          handleChangeView={handleChangeView}
          toggleButtonStyle={toggleButtonStyle}
        />
      </Grid>
      <Grid item xs={12}>
        {view === 'add' && <AddCompanyQuotaView />}
        {view === 'remove' && <QuotaRemoval mode="company" />}
        {view === 'update' && (
          <>
            <Grid item xs={12}>
              <UpdateFiscalQuarterFilter touched={touched} setTouched={setTouched} fetchData={fetchCompanyQuotaData} type="company" />
            </Grid>
            <CompanyQuotaPanel setTouched={setTouched} />
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default CompanyManagementContainer;
